import Link from "next/link"
import { EditIcon } from "@/components/svg/EditIcon"
import { SettingsIcon } from "@/components/svg/SettingsIcon"

const ProfileControls = ({ openDrawer }: { openDrawer: () => void }) => {
  return (
    <div className="fixed bottom-2 w-full pointer-events-none flex items-center justify-center z-50">
      <div className="flex items-center justify-center bg-blue-700 rounded-3xl shadow-md pointer-events-auto border-2 border-blue-400">
        <button
          title="Edit profile"
          onClick={openDrawer}
          className="p-4 text-white/80 px-6 hover:text-white hover:bg-blue-800 rounded-l-3xl transition"
        >
          <EditIcon className="w-8 h-8" />
        </button>
        <Link
          title="Settings"
          href="/settings"
          className="p-4 text-white/80 px-6 hover:text-white hover:bg-blue-800 rounded-r-3xl transition"
        >
          <SettingsIcon className="w-8 h-8" />
        </Link>
      </div>
    </div>
  )
}

export default ProfileControls
